const trackAnalyticsEvent = (name, value = '', action = '', elementType = '') => {
  const ev = new CustomEvent('refi-track-event', {
    bubbles: true,
    composed: true,
    detail: {
      name,
      value,
      action,
      elementType,
    },
  });
  document.dispatchEvent(ev);
};

export { trackAnalyticsEvent };
